import React from "react";
import {
  Beaker,
  HeartHandshake,
  Smile,
  Users,
} from "lucide-react";
import { Link } from "react-router-dom";

const WhyTrustUs = () => {
  const colors = {
   pageBg: "#F9FBFA",     // Logo ke Sage Green ka light variant (Clean & Professional)
  cardBg: "#FFFFFF",     // Pure White for main cards
  accent: "#D7A19E",     // Logo ka Muted Rose (Warm & Caring)
  dark: "#546E7A",       // Logo ka Dark Slate Blue (Trust & Authority)
  text: "#4A5A64",
  };

  const features = [
    {
      title: "Modern IVF Lab",
      description:
        "State-of-the-art laboratories with the latest technology to ensure high success rates.",
      icon: <Beaker />,
    },
    {
      title: "Personalized Care",
      description:
        "Every treatment plan is tailored uniquely for each couple's needs and goals.",
      icon: <HeartHandshake />,
    },
    {
      title: "Affordable Care",
      description:
        "Clear pricing and ethical practices, ensuring accessibility without hidden costs.",
      icon: <Smile />,
    },
    {
      title: "Family First",
      description:
        "We treat you as family, offering emotional support alongside medical expertise.",
      icon: <Users />,
    },
  ];

  return (
    <section
      className="py-24 px-4 md:px-10"
      style={{ backgroundColor: colors.pageBg }}
    >
      {/* BIG OUTER CARD */}
     <div
  className="max-w-7xl mx-auto rounded-[3rem] p-10 md:p-16 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.08)] relative overflow-hidden"
  style={{
    backgroundImage: "url('')", // 👈 yaha image path
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span
            className="uppercase tracking-[0.3em] text-[30px] font-bold"
            style={{ color: colors.accent }}
          >
            Our Commitment
          </span>

          <h2
            className="text-3xl md:text-5xl  mt-4 mb-6"
            style={{ color: colors.dark }}
          >
            Why Families <span>Choose Us</span>
          </h2>

          <p
            style={{ color: "white" }}
            className="text-lg font-light leading-relaxed"
          >
            At Dr. Vibha's Clinic, we blend pioneering science with deep human
            connection to turn your dreams into reality.
          </p>
        </div>

        {/* FEATURE CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white p-8 rounded-3xl transition-all duration-500 
              hover:-translate-y-3 hover:shadow-[0_25px_60px_-10px_rgba(183,110,121,0.25)]"
              style={{
                borderTop: `4px solid ${colors.accent}`,
              }}
            >
              {/* Icon */}
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 
                transition-all duration-500 group-hover:scale-110"
                style={{
                  backgroundColor: "#FFF5F6",
                  color: colors.accent,
                }}
              >
                {React.cloneElement(feature.icon, {
                  size: 30,
                  strokeWidth: 1.5,
                })}
              </div>

              <h3
                className="text-lg font-semibold mb-3"
                style={{ color: colors.dark }}
              >
                {feature.title}
              </h3>

              <p
                className="text-sm leading-relaxed mb-6"
                style={{ color: colors.text }}
              >
                {feature.description}
              </p>

          
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="mt-16 text-center">
          <Link to="/contact-us">
            <button
              className="px-10 py-4 rounded-xl text-xs font-bold uppercase tracking-[0.2em] 
              transition-all duration-300 hover:scale-105 hover:shadow-lg"
              style={{
                backgroundColor: colors.accent,
                color: "#fff",
              }}
            >
              Contact Our Experts
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;
